export enum QuestionnaireModal {
  "PENDING" = "Your responses have been saved.",
  "SUBMITTED" = "Your responses have been submitted."
}
